import { LanguageTag } from '@phensley/language-tag';
import { rawLocales } from './autogen.locales';
var allLocales = [];
/**
 * @public
 */
export var availableLocales = function () {
    if (!allLocales.length) {
        var k_1 = Object.keys;
        var a_1 = rawLocales;
        k_1(a_1).forEach(function (l) {
            var b = a_1[l];
            k_1(b).forEach(function (s) {
                var c = b[s];
                var e = c.length - 1;
                var re = c[e].split(' ');
                for (var i = 0; i < re.length; i++) {
                    var f = c[i];
                    var x = [];
                    /* istanbul ignore else */
                    if (f & 1 /* Flags.LANG */) {
                        x.push(l);
                    }
                    if (f & 2 /* Flags.SCRIPT */) {
                        x.push(s);
                    }
                    var r = re[i];
                    var v = void 0;
                    var _v = f & 8 /* Flags.VARIANT */;
                    if (_v) {
                        var p = r.split('-');
                        r = p[0];
                        v = p[1];
                    }
                    if (f & 4 /* Flags.REGION */) {
                        x.push(r);
                    }
                    if (_v) {
                        x.push(v);
                    }
                    allLocales.push({
                        id: x.join('-'),
                        tag: new LanguageTag(l, s, r, v),
                    });
                }
            });
        });
    }
    return allLocales;
};
